import { directionArr } from "../configParams";

export const consecutiveMovementsArr = (movementValue, arrOfMovements) => {
  if (arrOfMovements.length > 0) {
    if (
      movementValue === arrOfMovements[arrOfMovements.length - 1] &&
      directionArr.includes(movementValue)
    ) {
      arrOfMovements.push(movementValue);
    } else {
      arrOfMovements.forEach((movement) => {
        arrOfMovements.pop();
      });
    }
  } else if (
    arrOfMovements.length === 0 &&
    directionArr.includes(movementValue)
  ) {
    arrOfMovements.push(movementValue);
  }

  return arrOfMovements;
};
